








































import { Component, Vue } from 'vue-property-decorator'
import { NoCache } from '@/decorators'
import { Action, Getter } from 'vuex-class'
import { Invoice, Receipt } from '@/services/models'

import EditInvoiceModal from '@/components/EditInvoiceModal.vue'
import PageTitle from '@/components/PageTitle.vue'
import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    EditInvoiceModal,
    PageTitle,
  },
})
export default class Invoices extends Vue {

  @Getter('firestore/invoices')
  private items!: Invoice[]

  @Getter('firestore/receipt')
  private readReceipt!: (receiptId: string) => Receipt|undefined

  @Action('firestore/fetchInvoices')
  private fetchInvoices!: () => Promise<Invoice[]>

  @Action('firestore/fetchReceipts')
  private fetchReceipts!: () => Promise<Receipt[]>

  @Action('firestore/deleteInvoice')
  private deleteInvoice!: (invoiceId: string) => Promise<void>

  @NoCache
  public get editingModal(): EditInvoiceModal {
    return this.$refs.editingModal as EditInvoiceModal
  }

  private get fields(): Array<string|any> {
    return [
      { key: 'code', label: 'CODE' },
      { key: 'customer.name', label: 'CUSTOMER NAME' },
      { key: 'totalAmount', class: 'text-right', label: 'TOTAL', formatter: formatters.decimal },
      { key: 'lastUpdated', class: 'text-center', label: 'LAST UPDATED', formatter: formatters.relativeDateTime },
      { key: 'actions', label: 'ACTIONS' },
    ]
  }

  public mounted() {
    this.fetchInvoices()
    this.fetchReceipts()
  }

  public isReceiptMissing(receiptId: string): boolean {
    return !Boolean(this.readReceipt(receiptId))
  }

  private edit(invoice: Invoice) {
    this.editingModal.edit(invoice)
  }

  private createNew() {
    this.editingModal.create()
  }

  private async onModalCommitted(invoice: Invoice) {
    // pass
  }
}
